import http from '../../../Utils/http';
const Stripeonboarding = {
  name: 'stripeonboarding',
  state: {
    loading: false,
    error: '',
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
    message: ''
  },
  reducers: {
    stripeonboardingRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        message: ''
      };
    },
    stripeonboardingReceived(state, payload) {
      return {
        ...state,
        loading: false,
        message: payload,
        error: '',
      }
    },
    stripeonboardingRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        message: '',
        loading: false,
      };
    },

  },
  effects: (dispatch) => ({
    async requestForStripeOnboarding(data) {
      try {
        this.stripeonboardingRequested();
        const response = await http.post(`savvy/users/connect`, data);
        this.stripeonboardingReceived(response.data.redirect);
        dispatch.ProgressStepDSO.UpdateGetDSOProgressStep(4);
      } catch (err) {
        this.stripeonboardingRequestFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async clearData() {
      this.stripeonboardingReceived('');
    }
  }),
};

export default Stripeonboarding;